module.exports = __webpack_public_path__ + "media/images/btn_create_booking-9155ee1acff5dafe29002b8c481521dc.gif";